import browser from '../../browser';

const pixelToRem = (px, base = 16) => browser.window.parseInt(px, 10) / base;

export default pixelToRem;
